// removed by extract-text-webpack-plugin
module.exports = {"header":"subject-summary__header___3prC7","treatmentStatus":"subject-summary__treatmentStatus___1UH6c","treatmentActive":"subject-summary__treatmentActive___xmiVc","treatmentInactive":"subject-summary__treatmentInactive___tV8gS","treatmentArchived":"subject-summary__treatmentArchived___2BkzC"};


//////////////////
// WEBPACK FOOTER
// ./study_coordinator/src/components/subjects/subject-summary.css
// module id = 1209
// module chunks = 0